import { convertColorStringToRgb } from './wcag.convert-color-to-rgb.js';
import { verifyWCAGContrastRatio } from './wcag.verify-contrast-ratio.js';

/**
 * utility to handle WCAG contrast ratio verification between a background
 * color and text color, automatically inverting between two colors based on
 * the contrast ratio
 *
 * gracefully handles edge cases to allow selecting the preferred color as
 * often as it makes sense
 */
function invertColorByWCAGContrastRatio(backgroundColor, textColor, {
  laxRatio,
  silent = false,
  ...options
} = {}) {
  const computedBackgroundColor = typeof backgroundColor === "function" ? `${backgroundColor.r.defaultValue} ${backgroundColor.g.defaultValue} ${backgroundColor.b.defaultValue}` : backgroundColor;
  const preferredColor = typeof textColor.preferredColor === "function" ? `${textColor.preferredColor.r.defaultValue} ${textColor.preferredColor.g.defaultValue} ${textColor.preferredColor.b.defaultValue}` : textColor.preferredColor;
  const invertedColor = typeof textColor.invertedColor === "function" ? `${textColor.invertedColor.r.defaultValue} ${textColor.invertedColor.g.defaultValue} ${textColor.invertedColor.b.defaultValue}` : textColor.invertedColor;
  if (verifyWCAGContrastRatio(computedBackgroundColor, preferredColor, {
    ...options,
    laxRatio
  })) {
    return typeof textColor.preferredColor === "function" ? textColor.preferredColor : convertColorStringToRgb(textColor.preferredColor, {
      silent
    })?.toString();
  }
  if (!verifyWCAGContrastRatio(computedBackgroundColor, invertedColor, options)) {
    // if the inverted color doesn't match WCAG ratio either, then use the
    // default color knowing we fail WCAG ratio
    if (!silent) {
      console.warn("invertColorByWCAGContrastRatio: no text colors match requirements for bgColor '%s', using '%s' instead of '%s'", backgroundColor, preferredColor, invertedColor);
    }
    return typeof textColor.preferredColor === "function" ? textColor.preferredColor : convertColorStringToRgb(textColor.preferredColor, {
      silent
    })?.toString();
  }
  return typeof textColor.invertedColor === "function" ? textColor.invertedColor : convertColorStringToRgb(textColor.invertedColor, {
    silent
  })?.toString();
}

export { invertColorByWCAGContrastRatio };
//# sourceMappingURL=wcag.auto-invert-color.js.map
